import translate from 'utils/apa/translations';
import { getTranslation } from 'utils/getTranslation';

export const MODAL_ERROR = 'ErrorSimple';
export const MODAL_SUCCESS = 'SuccessSimple';

export const emptyValidation = (translations)=> getTranslation('profile_empty_field', translations);
export const firstNameValidation = (translations)=> getTranslation('registro_nombre_error_gen', translations);
export const lastNameValidation = (translations)=> getTranslation('registro_apellido_error_gen', translations);

export const getLabels = (translations) => {
  const header = getTranslation('profile_my_data_title', translations);
  const title = getTranslation('profile_my_data_subtitle', translations);
  const email = getTranslation('profile_email', translations);
  const firstName = getTranslation('profile_firstname', translations);
  const lastName = getTranslation('profile_lastname', translations);
  const modify = getTranslation('profile_button_modify', translations);
  const cancel = getTranslation('profile_button_cancel', translations);
  const save = getTranslation('profile_button_save', translations);
  return {
    header,
    title,
    email,
    firstName,
    lastName,
    modify,
    cancel,
    save,
  };
};

export const getMessage = ({ code, message, translations }) => getTranslation(code, message, translations) || message;
